import React from 'react';
import DataTable from '../../../DataTable';
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';

@inject('workOrderStore', 'inventoryItemStore', 'userStore')
@observer
class WorkOrderTaskList extends React.Component {

  slug = this.props.params.work_order_id ? `station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view/tasks` : `monitoring/work_order/tabular/${this.props.params.id}/view/tasks`;

  actionColumn = [
    {key: 'id', label: 'Id'},
    {key: 'description', label: 'Description'},
    {key: 'item', label: 'Item'},
    {key: 'assigned_to', label: 'Assigned To'},
    {key: 'estimated_man_hours', label: 'Estimated Man Hours'},
    {key: 'hours_spent', label: 'Hours Spent'},
    {key: 'task_result', label: 'Task Result'},
    {key: 'task_status', label: 'Task Status'},
  ];

  handleDelete = (idOrIds) => this.props.workOrderStore.removeTaskItem(this.props.workOrder_id, idOrIds);

  render() {
    const {workOrderStore, workOrder_id, inventoryItemStore, userStore} = this.props;
    let items = workOrderStore.tasks.map(item => {
      let inventoryItem = inventoryItemStore.findById(item.item_id),
        assigned_to = userStore.findById(item.assigned_to);
      return {
        id: item.id,
        description: item.description,
        item: inventoryItem && inventoryItem.serial_no,
        assigned_to: assigned_to && assigned_to.name,
        estimated_man_hours: item.estimated_man_hours,
        hours_spent: item.hours_spent,
        task_result: item.task_result,
        task_status: item.task_status
      }
    });
    return (
      <div>
        <DataTable data={items} slug={this.slug} columns={this.actionColumn} onDelete={this.handleDelete}
                   allowAdd
                   allowEdit
                   allowDelete
        />
        {this.props.children ? React.cloneElement(this.props.children, {workOrder_id}) : null}
      </div>
    );
  }
}

export default WorkOrderTaskList;


// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/Task/WorkOrderTaskList.js